

















































import Vue from 'vue';
import Component from 'vue-class-component';
import { mapGetters, mapState } from 'vuex';
import NpRadio from '@/components/NpRadio.vue';
import ACHAccount from '@/models/ACHAccount';
import CreditCard from '@/models/CreditCard';
import Account from '@/models/Account';

export default Vue.extend({
	name: 'PaymentMethodSelector',

	components: {
		NpRadio,
	},

	props: {
		account: Object,
		enableNewCard: Boolean,
		noAch: Boolean,
		register: Boolean,
		value: String,
	},

	computed: {
		...mapState(['loggedInCustomer']),
		...mapGetters('location', ['hasAch', 'location', 'subLocations']),

		achAccount(): ACHAccount | undefined {
			return this.account.ach_accounts.find((account: ACHAccount) => +account.location === +this.location.subLocation);
		},

		achAvailable(): boolean {
			return this.hasAch && !this.noAch;
		},

		allowNewCard(): boolean {
			return this.enableNewCard && (!this.account.primaryCard || !this.account.secondaryCard);
		},

		model: {
			get(): string {
				return this.value;
			},

			set(value: string) {
				this.$emit('input', value);
			},
		},

		onlyNewCard(): boolean {
			return false;

			/* return this.enableNewCard
				&& !this.customer.primaryCard
				&& !this.customer.secondaryCard
				&& !this.achAvailable; */
		},

		onlyNewAch(): boolean {
			return false;
			/* return this.achAvailable
				&& !this.customer.primaryCard
				&& !this.secondaryCard
				&& !this.enableNewCard
				&& !this.achAccounts.length; */
		},
	},

	mounted() {
		// Set a payment method if nothing is initially set.
		if (!this.model) {
			const radio = this.$el.querySelector('input[type=radio]');
			if (radio) {
				this.model = (radio as HTMLInputElement).value;
			}
		}

		if (this.onlyNewAch) {
			this.model = 'new_ach';
		}

		this.model = 'new_cc';
	},
});
